/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Plan, Plans } from 'cio/utils/billing/plans';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import BillingService from 'cio/services/billing';
import { action } from '@ember/object';
import getCurrentPlan from 'cio/utils/billing/current-plan';

export type HighlightLink = { label: string; href: string };
export type HighlightRoute = { label: string; route: string; query?: Record<string, string> };
export type Highlight = string | HighlightLink | HighlightRoute;

interface PlanHighlightsArgs {
  highlights: Highlight;
  planTemplate: Plan;
  showCheckout?: boolean;
  cdpPlan: boolean;
}

export default class PlanHighlights extends Component<PlanHighlightsArgs> {
  @service account!: AccountService;
  @service analytics!: AnalyticsService;
  @service billing!: BillingService;

  get highlightHeader() {
    switch (this.args.planTemplate) {
      case (Plans.Essentials, Plans.CdpStarter, Plans.StartupBasic, Plans.StartupPlus): {
        return 'Core features';
      }
      case Plans.Premium: {
        return 'Everything in Essentials, plus';
      }
      case Plans.Enterprise: {
        return 'Everything in Premium, plus';
      }
      case Plans.CdpPremium: {
        return 'Everything in Starter, plus';
      }
      default: {
        return 'Core features';
      }
    }
  }

  get showCheckout() {
    return this.args.showCheckout ?? false;
  }

  get viewAllFeaturesUrl() {
    if (this.args.cdpPlan) {
      return 'https://customer.io/pricing/data-pipelines/';
    } else {
      return 'https://customer.io/pricing/';
    }
  }

  @action
  trackViewAllFeatures() {
    let { account } = this;
    let { currentUser } = account.current;
    let { billingInfo } = this.billing;

    let currentPlanInfo = getCurrentPlan(billingInfo, this.billing.subscription?.plan.planType);

    let data = {
      account_id: account.current.id,
      requester: currentUser.fullName,
      requester_email: currentUser.email,
      requester_user_id: currentUser.id,
      current_plan: currentPlanInfo,
      viewed_feature_list: this.args.planTemplate.name,
    };
    this.analytics.track('plan_billing', 'view_all_features_clicked', { data });
  }
}
